import { forwardRef } from 'react';
import {
  Tooltip as NextUITooltip,
  type TooltipProps as NextUITooltipProps,
} from '@heroui/tooltip';

export interface TooltipProps extends NextUITooltipProps {
  maxWidth?: string;
}

const Tooltip = forwardRef((props: TooltipProps, ref: any) => {
  if (!props.content) return props.children;

  return (
    <NextUITooltip
      ref={ref}
      {...props}
      showArrow={props.showArrow ?? true}
      delay={0}
      closeDelay={0}
      classNames={{
        base: ['before:bg-black', props.maxWidth ? `${props.maxWidth}` : 'max-w-64'],
        content: ['py-2 px-3 rounded-md text-xs', 'bg-black text-default-50 dark:text-grey-50'],
      }}
    />
  );
});

export default Tooltip;
